import yup from 'utils/yupHelpers';
import { capturePayment as TEXT } from 'locales/en/transaction';

const schema = yup.object().shape({
  amount: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .positive(TEXT.errors.amount.required)
    .required(TEXT.errors.amount.required),
});

export default schema;
